import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PostHogProvider } from 'posthog-js/react';

import './index.css';

import { App } from './App.tsx';

Sentry.init({
	dsn: import.meta.env.VITE_PUBLIC_SENTRY_DSN,
});

const options = {
	api_host: import.meta.env.DEV
		? ''
		: import.meta.env.VITE_PUBLIC_POSTHOG_API_HOST!,
	ui_host: import.meta.env.DEV
		? ''
		: import.meta.env.VITE_PUBLIC_POSTHOG_UI_HOST!,
};

createRoot(document.getElementById('root')!).render(
	<PostHogProvider
		apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY!}
		options={options}
	>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</PostHogProvider>
);
